<template>
  <div class="case-creation__step case-creation__test" v-loading="loading">
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="case-creation__card attachments border-bottom-none">
          <div class="case-creation__heading">
            <div class="title-with-icon">
              <span class="icon">
                <img
                  src="@/assets/images/icons/icon-test-reports.svg"
                  alt="icon"
                  class="img-fluid"
                />
              </span>
              <h3 class="title">Test Results</h3>
            </div>
          </div>
          <div class="case-creation__test-reports">
            <el-tabs v-model="activeCaseName" v-on:tab-click="selectedTabTest">
              <el-tab-pane
                class="blood-panel-test-results"
                label="Clinical Chemistry"
                v-if="hasBloodPanel"
                name="blood"
              >
                <div
                  class="test-results"
                  v-if="getCaseInformation.status !== 'REJECTED'"
                >
                  <ul class="test-btn" v-if="testResults && testResults.length">
                    <li>
                      <el-button
                        class="test-preview"
                        @click="previewTestResultsData()"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >PREVIEW</el-button
                      >
                    </li>
                    <li v-if="isLabUser && checkLab">
                      <el-button
                        class="test-reports"
                        @click="saveAndGenerateBloodReport"
                        v-if="caseStatus != 'COMPLETE'"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >SAVE & GENERATE PRILIMINARY REPORT</el-button
                      >
                    </li>
                  </ul>
                </div>
                <div
                  class="results-tabs"
                  v-if="
                    getCaseInformation.status !== 'REJECTED' &&
                    bloodResults &&
                    Object.keys(bloodResults) &&
                    Object.keys(bloodResults).length
                  "
                >
                  <div class="test-inputs">
                    <div
                      v-for="(test, groupName, index) in bloodResults"
                      :key="index"
                      class="blood-panel-section"
                    >
                      <h3 class="section-title">{{ groupName }}</h3>

                      <el-table :data="test">
                        <el-table-column
                          label="Test Name"
                          min-width="150"
                          class="result"
                        >
                          <template #default="scope">
                            <el-input 
                              class="input-width"
                              v-model="test[scope.$index].result_name"
                              :class="getFlagClass(test[scope.$index].flag, test[scope.$index].result_value || test[scope.$index].result)"
                              placeholder="Enter name"
                              :disabled="true"
                            ></el-input>
                          </template>
                        </el-table-column>

                          <el-table-column :label="checkAllgenPanel(test) ? 'LMC VALUE' : 'RESULT'" min-width="130">
                            <template #default="scope">
                              <template
                                v-if="
                                  test[scope.$index].result_name ===
                                  'HIV Screening'
                                "
                              >
                                <el-select
                                  class="input-width"
                                  v-model="test[scope.$index].result"
                                  :disabled="caseStatus === 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                >
                                  <el-option
                                    v-for="status in statuses"
                                    :key="status"
                                    :label="status"
                                    :value="status"
                                  ></el-option>
                                </el-select>
                              </template>
                              <template
                                v-else-if="
                                  test[scope.$index].result_name === 'Syphilis' ||
                                  test[scope.$index].result_name === 'Hepatitis B Surface Antigen' ||
                                  test[scope.$index].result_name === 'HIV ANTIGEN/ANTIBODY'
                                "
                              >
                                <el-select
                                  v-model="test[scope.$index].result"
                                  :disabled="caseStatus === 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                >
                                  <el-option
                                    v-for="status in statusesReact"
                                    :key="status"
                                    :label="status"
                                    :value="status"
                                  ></el-option>
                                </el-select>
                              </template>
                              <template
                                v-else-if="
                                  test[scope.$index].result_name === 'Hepatitis B Surface Antibody' ||
                                  test[scope.$index].result_name === 'Hepatitis B Core Antibody' ||
                                  test[scope.$index].result_name === 'Hepatitis C Virus Antibody' ||
                                  test[scope.$index].result_name === 'Hepatitis B Core Antibody,IgM' ||
                                  test[scope.$index].result_name === 'Hepatitis A Antibody, IgM'
                                "
                              >
                                <el-select
                                  v-model="test[scope.$index].result"
                                  :disabled="caseStatus === 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                >
                                  <el-option
                                    v-for="status in hepatitisSatuses"
                                    :key="status"
                                    :label="status"
                                    :value="status"
                                  ></el-option>
                                </el-select>
                              </template>
                            <template v-else>
                              <el-input
                                class="input-width"
                                v-model="test[scope.$index].result"
                                :class="getFlagClass(test[scope.$index].flag, test[scope.$index].result_value || test[scope.$index].result)"
                                placeholder="--"
                                :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                @input="updateFlag(test, scope.$index)"
                                @keypress="onlyNumberOrComparison($event)"
                              ></el-input>
                            </template>
                          </template>
                        </el-table-column>
                         <el-table-column v-if="!checkAllgenPanel(test)" label="UNITS" min-width="130">
                          <template #default="scope">
                            <el-input
                              class="input-width"
                              v-model="test[scope.$index].units"
                              placeholder="Enter units"
                              :disabled="true"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <el-table-column
                          class="input-width"
                          v-if="!checkAllgenPanel(test)"
                          label="REFERENCE RANGE"
                          min-width="170"
                        >
                          <template #default="scope">
                            {{ test[scope.$index].reference_range_html }}
                          </template>
                        </el-table-column>
                        <el-table-column label="FLAG" min-width="120">
                          <template #default="scope">
                            <el-input
                              v-model="test[scope.$index].flag"
                              :class="getFlagClass(test[scope.$index].flag, test[scope.$index].result_value || test[scope.$index].result)"
                              placeholder="Enter flag name"
                              :disabled="true"
                            ></el-input>
                          </template>
                        </el-table-column>
                          <el-table-column
                          v-if="isAbleToGenerateResendEMR"
                          label="EMR Order Code"
                          min-width="100"
                        >
                          <template #default="scope">
                            <el-input
                              v-model="test[scope.$index].emr_order_code"
                              placeholder="Enter EMR Code"
                            ></el-input>
                          </template>
                        </el-table-column>
                        <!-- Dynamic Previous Results -->
                      <template v-for="date in previousResultDates" :key="date">
                        <el-table-column :label="formatDate(date)" min-width="130">
                          <template #default="scope">
                            <div
                              class="previous-result-cell"
                              v-html="getPreviousResultsWithFlagsForDate(
                                test[scope.$index].result_name,
                                date,
                                test[scope.$index].test_name_code
                              )"
                            ></div>
                          </template>
                        </el-table-column>
                      </template>
                      </el-table>
                    </div>
                  </div>
                  <div
                    class="testReportCommentBox"
                    v-if="caseStatus != 'COMPLETE'"
                  >
                    <el-input
                      type="textarea"
                      placeholder="Enter comment"
                      v-model="bloodComment"
                    ></el-input>
                  </div>
                  <!-- <div class="save-btn">
                    <el-button
                      type="success"
                      @click="updateResultsData"
                      v-if="
                        caseStatus != 'COMPLETE' || isAbleToGenerateResendEMR
                      "
                      :disabled="checkUser && !hasAllowedCaseType"
                      >Save</el-button
                    >
                  </div> -->
                </div>
              </el-tab-pane>
              <el-tab-pane label="Urinalysis" v-if="hasUrineTest" name="urine">
                <div class="test-results">
                  <ul
                    class="test-btn"
                    v-if="urineTestResults && urineTestResults.length"
                  >
                    <li
                      v-if="
                        machineResults &&
                        machineResults.length &&
                        caseStatus != 'COMPLETE'
                      "
                    >
                      <span class="test-mismatched" v-if="mismatched">
                        MACHINE RESULTS ARE MISMATCHED
                      </span>
                      <span class="test-success" v-else>
                        MACHINE RESULTS ARE AVAILABLE
                      </span>

                      <el-button class="view-results" @click="openResultsPopup">
                        View results
                      </el-button>
                    </li>
                    <li v-else>
                      <span class="test-danger" v-if="caseStatus != 'COMPLETE'">
                        MACHINE RESULTS NOT AVAILABLE</span
                      >
                    </li>
                    <li class="d-flex">
                      <el-button
                        class="test-preview"
                        @click="previewUrineTestResultsData()"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >PREVIEW</el-button
                      >
                      <el-button
                        class="test-reports"
                        @click="saveAndGenerateUrineReport"
                        v-if="caseStatus != 'COMPLETE'"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >SAVE & GENERATE REPORT</el-button
                      >
                    </li>
                  </ul>
                  <ul v-else class="test-btn">
                    <li
                      v-if="
                        machineResults &&
                        machineResults.length &&
                        caseStatus != 'COMPLETE'
                      "
                    >
                      <span class="test-success">
                        MACHINE RESULTS ARE AVAILABLE
                      </span>
                      <el-button class="view-results" @click="openResultsPopup">
                        View results
                      </el-button>
                    </li>
                    <li v-else>
                      <span class="test-danger">
                        MACHINE RESULTS NOT AVAILABLE</span
                      >
                    </li>
                    <li
                      v-if="
                        checkUser &&
                        !hasAllowedCaseType &&
                        hasPermission('cases', 'report_upload_new')
                      "
                    >
                      <el-button
                        class="test-reports"
                        @click="startResulting"
                        v-if="caseStatus != 'COMPLETE'"
                        >Start Resulting</el-button
                      >
                    </li>
                    <li v-else>
                      <el-button
                        class="test-reports"
                        @click="startResulting"
                        v-if="
                          caseStatus != 'COMPLETE' &&
                          hasPermission('cases', 'report_upload_new')
                        "
                        >Start Resulting</el-button
                      >
                    </li>
                  </ul>
                </div>
                <div
                  class="results-tabs"
                  v-if="
                    urineResults &&
                    Object.keys(urineResults) &&
                    Object.keys(urineResults).length
                  "
                >
                  <div
                    class="test-inputs"
                    :class="{
                      'hide-test-inputs': isHavingOneResults,
                    }"
                  >
                    <el-tabs
                      v-model="activeName"
                      class="demo-tabs"
                      @tab-click="handleClick"
                    >
                      <el-tab-pane
                        v-for="(test, index) of urineResults"
                        :key="index"
                      >
                        <el-table :data="test">
                          <el-table-column
                            fixed
                            label="RESULT NAME"
                            min-width="180"
                            class="result"
                          >
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].result_name"
                                :class="getFlagClass(test[scope.$index].flag, test[scope.$index].result_value || test[scope.$index].result)"
                                placeholder="Enter name"
                                :disabled="true"
                              ></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="INSTRUMENT" width="150">
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].instrument"
                                placeholder="Enter instrument"
                                :disabled="true"
                              ></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="INSTR.CODE" min-width="150">
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].instrument_code"
                                placeholder="Enter instrument code"
                                :disabled="true"
                              ></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column label="RESULT VALUE" min-width="180">
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].result_value"
                                :class="getFlagClass(test[scope.$index].flag, test[scope.$index].result_value || test[scope.$index].result)"
                                placeholder="Enter value"
                                :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                              ></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column label="UNITS" min-width="180">
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].units"
                                placeholder="Enter units"
                                :disabled="true"
                              ></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column
                            label="REFERENCE RANGE"
                            min-width="150"
                          >
                            <template #default="scope">
                              {{
                                test[scope.$index].lower_limit +
                                "-" +
                                test[scope.$index].upper_limit
                              }}
                            </template>
                          </el-table-column>
                          <el-table-column label="FLAG" min-width="100">
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].flag"
                                :class="getFlagClass(test[scope.$index].flag, test[scope.$index].result_value || test[scope.$index].result)"
                                placeholder="Enter flag name"
                                :disabled="true"
                              ></el-input>
                            </template>
                          </el-table-column>
                          <el-table-column label="DILUTION" min-width="120">
                            <template #default="scope">
                              <el-input
                                v-model="test[scope.$index].dilution"
                                placeholder="Enter dilution"
                                :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                              ></el-input>
                            </template>
                          </el-table-column>

                          <el-table-column label="COMMENTS" min-width="180">
                            <template #default="scope">
                              <el-input
                                type="input"
                                v-model="test[scope.$index].comments"
                                placeholder="Enter comment"
                                :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                              ></el-input>
                            </template>
                          </el-table-column>
                          <template v-for="item in urinePreviousAccessions" :key="item.acc">
                            <el-table-column
                              :label="item.acc"
                              min-width="140"
                            >
                              <template #header>
                                <div class="urine-prev-header">
                                  <div class="urine-prev-acc-label">{{ item.acc }}</div>
                                  <div class="urine-prev-date-label">{{ formatDate(item.date) }}</div>
                                </div>
                              </template>
                              <template #default="scope">
                                <div
                                  class="urine-prev-cell"
                                  :class="getUrineFlagClass(getUrinePreviousValue(test[scope.$index].result_name, item.acc)?.flag)"
                                >
                                  {{ getUrinePreviousValue(test[scope.$index].result_name, item.acc)?.value ?? '—' }}
                                </div>
                              </template>
                            </el-table-column>
                          </template>
                        </el-table>
                      </el-tab-pane>
                    </el-tabs>
                  </div>
                  <!-- <div class="save-btn" v-if="(!urineTestResults || !urineTestResults.length) && caseStatus != 'COMPLETE'">
                    <el-button
                      type="success"
                      @click="updateUrineResultsData"
                      :disabled="checkUser && !hasAllowedCaseType"
                      >Save</el-button
                    >
                  </div> -->
                </div>
              </el-tab-pane>
              <el-tab-pane
                label="Toxicology"
                class="toxicology-edit-preview"
                v-if="hasToxicTest"
                name="toxic"
              >
                <div
                  class="test-results"
                  v-if="hasPermission('result_files', 'add')"
                >
                  <ul class="test-btn" v-if="showResultsEditing">
                    <li>
                      <el-button
                        class="test-reports"
                        @click="startToxicologyResulting"
                        v-if="caseStatus != 'COMPLETE'"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >Sync Results</el-button
                      >
                    </li>
                    <li>
                      <el-button
                        class="test-preview"
                        @click="previewToxicologyResults()"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >PREVIEW</el-button
                      >
                    </li>

                    <li>
                      <el-button
                        class="test-reports"
                        @click="generateToxiocologyReport"
                        v-if="caseStatus != 'COMPLETE'"
                        :disabled="checkUser && !hasAllowedCaseType"
                        >GENERATE</el-button
                      >
                    </li>
                  </ul>
                  <ul class="test-btn" v-else>
                    <li v-if="checkUser && !hasAllowedCaseType">
                      <el-button
                        class="test-reports"
                        @click="startToxicologyResulting"
                        v-if="
                          caseStatus != 'COMPLETE' &&
                          hasPermission('cases', 'report_upload_new')
                        "
                        :disabled="havingToxTestInfo"
                        >Start Resulting</el-button
                      >
                    </li>
                    <li v-else>
                      <el-button
                        class="test-reports"
                        @click="startToxicologyResulting"
                        v-if="
                          caseStatus != 'COMPLETE' &&
                          hasPermission('cases', 'report_upload_new')
                        "
                        :disabled="havingToxTestInfo"
                        >Start Resulting</el-button
                      >
                    </li>
                  </ul>
                </div>
                <div
                  class="test-inputs"
                  v-if="hasPermission('result_files', 'add')"
                >
                  <el-form ref="form" :model="toxicologyData">
                    <div class="screening-block">
                      <div
                        class="primary-data-entry"
                        v-if="hasScreeingValidity"
                      >
                        <h3 class="primary-header">Screen Validity</h3>

                        <el-table :data="screenValidity">
                          <el-table-column
                            prop="Full Name"
                            label="Drug"
                            min-width="250"
                          >
                            <template #default="scope">
                              <div class="dark-blue-color">
                                {{
                                  scope.row.report_test_name ||
                                  scope.row["Full name"]
                                }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="result"
                            label="Result"
                            min-width="180"
                          >
                            <template #default="scope">
                              <div class="pr-20">
                                <el-input
                                  v-model="scope.row.result"
                                  placeholder="Enter Result"
                                  :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                  @input="
                                    checkScreeningValidityTestValues(scope.row)
                                  "
                                ></el-input>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="resultValue"
                            label="Results Value"
                            min-width="180"
                          >
                            <template #default="scope">
                              <div class="pr-20">
                                <el-input
                                  v-model="scope.row.result_value"
                                  placeholder="Enter Result Value"
                                  readonly
                                ></el-input>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="cutOff"
                            label="Cut Off"
                            width="200"
                          >
                            <template #default="scope">
                              <span v-if="scope.row.cutoff">{{
                                scope.row.cutoff +
                                " " +
                                (scope.row.report_test_name != "pH"
                                  ? "ng/mL"
                                  : "")
                              }}</span>
                              <span v-else>--</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>

                      <div class="primary-data-entry" v-if="hasScreeingTests">
                        <h3 class="primary-header">Screen Results</h3>

                        <el-table :data="screenResults" style="width: 100%">
                          <el-table-column
                            prop="Full Name"
                            label="Drug"
                            min-width="250"
                          >
                            <template #default="scope">
                              <div class="dark-blue-color">
                                {{ scope.row.test_name }}
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="result"
                            label="Result"
                            min-width="180"
                          >
                            <template #default="scope">
                              <div class="pr-20">
                                <el-input
                                  v-model="scope.row.result"
                                  placeholder="Enter Result"
                                  :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                  @input="checkScreeningTestValues(scope.row)"
                                ></el-input>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="resultValue"
                            label="Results Value"
                            min-width="180"
                          >
                            <template #default="scope">
                              <div class="pr-20">
                                <el-input
                                  v-model="scope.row.result_value"
                                  placeholder="Enter Result Value"
                                  readonly
                                ></el-input>
                              </div>
                            </template>
                          </el-table-column>
                          <el-table-column
                            prop="cutOff"
                            label="Cut Off"
                            width="200"
                          >
                            <template #default="scope">
                              <span
                                v-if="
                                  (scope.row.high_limit ||
                                    scope.row.low_limit) &&
                                  (scope.row.report_test_name === 'pH' ||
                                    scope.row.report_test_name === 'OXIDANTS')
                                "
                                >{{
                                  parseFloat(scope.row.low_limit) +
                                  "-" +
                                  parseFloat(scope.row.high_limit)
                                }}</span
                              >
                              <span v-else-if="scope.row.cutoff">{{
                                scope.row.cutoff +
                                " " +
                                (scope.row.report_test_name !=
                                "URINE CREATININE"
                                  ? scope.row.Units
                                  : "")
                              }}</span>
                              <span v-else>--</span>
                            </template>
                          </el-table-column>
                        </el-table>
                      </div>
                    </div>
                    <div
                      class="conformation-block pb-50"
                      v-if="hasConfirmationTests"
                    >
                      <h2 class="mt-20" v-if="hasConfirmationTests">
                        <span>
                          <img
                            src="@/assets/images/icons/confirmation-tests.svg"
                            alt="icon"
                          />
                        </span>
                        CONFIRMATION TESTS
                      </h2>
                      <div
                        class="primary-data-entry"
                        v-for="(test, index) of categoryCodes"
                        :key="index"
                      >
                        <div class="each-table">
                          <h3 class="primary-header">
                            {{ test.name }}
                          </h3>
                          <el-table :data="test.results" style="width: 100%">
                            <el-table-column
                              prop="report_test_name"
                              label="Test Screen"
                              min-width="250"
                              fixed="left"
                            >
                            </el-table-column>
                            <el-table-column
                              prop="testOutcome"
                              label="Test Outcome"
                              min-width="240"
                            >
                              <template #default="scope">
                                <div class="date-type-checkbox">
                                  <el-radio-group v-model="scope.row.flag">
                                    <el-radio
                                      label="Positive"
                                      value="detected"
                                    ></el-radio>
                                    <el-radio label="Not Detected"></el-radio>
                                  </el-radio-group>
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="result"
                              label="Measured Results"
                              min-width="150"
                            >
                              <template #default="scope">
                                <el-input
                                  type="text"
                                  v-model="scope.row.result"
                                  :disabled="caseStatus == 'COMPLETE' || !hasPermission('test_results', 'edit')"
                                  @input="
                                    checkConfirmationTestValues(scope.row)
                                  "
                                ></el-input>
                                <p v-if="scope.row.invalid_range">
                                  {{ scope.row.invalid_range }}
                                </p>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="determination"
                              label="Determination"
                              width="300"
                            >
                              <template #default="scope">
                                <div class="date-type-checkbox">
                                  <el-radio-group
                                    v-model="scope.row.interpretation"
                                  >
                                    <el-radio label="INCONSISTENT"></el-radio>
                                    <el-radio label="CONSISTENT"></el-radio>
                                  </el-radio-group>
                                </div>
                              </template>
                            </el-table-column>
                            <el-table-column
                              prop="cutoff"
                              align="center"
                              label="Cut Off"
                              width="100"
                            >
                              <template #default="scope">
                                <span v-if="scope.row.cutoff">{{
                                  scope.row.cutoff +
                                  " " +
                                  (scope.row.Units || scope.row.Unit)
                                }}</span>
                                <span v-else>--</span>
                              </template>
                            </el-table-column>
                            <el-table-column
                              align="center"
                              label="Range"
                              width="150"
                            >
                              <template #default="scope">
                                <span>{{
                                  scope.row.LLMI +
                                  "-" +
                                  scope.row.ULMI +
                                  " " +
                                  (scope.row.Units || scope.row.Unit)
                                }}</span>
                              </template>
                            </el-table-column>
                          </el-table>
                        </div>
                      </div>
                    </div>
                  </el-form>
                </div>
              </el-tab-pane>
              <div
                class="save-btn"
                v-if="
                  showResultsEditing && hasPermission('result_files', 'add')
                "
              >
                <el-button
                  type="success"
                  @click="askReason"
                  v-if="caseStatus != 'COMPLETE'"
                  :disabled="(checkUser && !hasAllowedCaseType) || !hasPermission('test_results', 'edit')"
                  >Save</el-button
                >
              </div>
            </el-tabs>
          </div>
        </div>
      </el-col>
    </el-row>
    <ResonForChange
      v-if="takeReasonDialog"
      v-on:close="takeReasonDialog = false"
      v-on:reasonSubmit="updateToxicologyResults"
      title="Reason for Update"
    ></ResonForChange>
    <MachineResults
      v-if="dialogVisible"
      v-on:close="dialogVisible = false"
      :urineTestResults="testResultsForUrine"
      :machineResults="machineResults"
      v-on:replaceValues="updateUrineResults"
    />
    <div class="default-modal">
      <el-dialog
        top="25vh"
        v-model="confirmDialogVisible"
        width="30%"
        @close="resetConfirmation"
      >
        <div class="dialog-header">
          <span class="header-part"> Confirm Report Generation </span>
          <el-button
            size="medium"
            class="el-white"
            type="info"
            plain
            @click="close"
          >
            <img src="@/assets/images/icons/cases/close-btn.svg" alt="icon"
          /></el-button>
        </div>
        <div class="popup-date pb-0">
          <p>Would you like to generate preliminary reports?</p>
        </div>
        <div class="dialog-footer" style="padding-right: 10px">
          <el-button class="cancel-button" @click="handleCancel"
            >Cancel</el-button
          >
          <el-button
            class="blue-save-button"
            type="primary"
            @click="handleConfirm"
            v-loading="buttonLoading"
            >Confirm</el-button
          >
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import $axios from "@/config/axios";
import AppHelper from "@/mixins/AppHelper";
import UserPermissionsHelper from "@/mixins/UserPermissionsHelper";
import UrinalysisConstants from "@/config/constants/urinalysisConstants";
import ResonForChange from "@/components/misc/ResonForChange";
import MachineResults from "@/components/cases/MachineResults";
import {
  successNotification,
  errorNotification,
} from "@/helpers/notifications";
import caseConstants from "@/config/constants/caseConstants";

export default {
  name: "",
  components: {
    ResonForChange,
    MachineResults,
  },
  mixins: [AppHelper, UserPermissionsHelper],
  data() {
    return {
      activeName: "",
      activeCaseName: "",
      loading: false,
      testResults: [],
      testResultsData: {},
      bloodResults: {},
      urineTestResults: [],
      testResultsForUrine: [],
      machineResults: [],
      accession_id: null,
      caseStatus: "",
      urineResults: {},
      urineTests: UrinalysisConstants.URINALYSIS_TESTS,
      urineTestsNew: UrinalysisConstants.URINALYSIS_TESTS_NEW,
      generatingUrineReportLoading: false,
      generateUrineReportDialogVisible: false,

      toxicologyData: {
        result: "",
        resultValue: "",
        testOutcome: "",
        measuredResults: "",
        creativeNormalized: "",
        determination: "",
      },
      toxicologyTable: [],
      medicationDialogVisible: false,
      caseId: null,
      reportData: null,
      testCategories: [],
      testReportURL: false,
      showTestReport: false,
      categoryCodes: [],
      screenResults: [],
      screenValidity: [],
      hasScreeingTests: false,
      hasConfirmationTests: false,
      hasScreeingValidity: false,
      prescribedMedications: [],
      showResultsEditing: false,
      takeReasonDialog: false,
      dialogVisible: false,
      mismatched: false,
      bloodTestData: {},
      bloodComment: "",
      confirmDialogVisible: false,
      buttonLoading: false,
      statuses: caseConstants.STATUSES,
      statusesReact: caseConstants.STATUSES_REACT,
      hepatitisSatuses : caseConstants.STATUSES_HEPATITIS,
      antibodyStatuses : caseConstants.STATUSES_ANTIBODY,
      urinePreviousResults: {},
      urinePreviousAccessions: [],
    };
  },
  async mounted() {
    this.caseId = this.$route.params.case_id;
    if (!this.getCaseInformation) {
      await this.$store.dispatch("cases/fetchCaseInformation", this.caseId);
    }
    await this.checkCaseInformation();
  },
  computed: {
    ...mapGetters("cases", [
      "getCaseInformation",
      "getTestResultsUpdateStatus",
      "getBloodReportGenerateStatus",
      "getTestResults",
      "getUrineTestResults",
      "getResultsAddStatus",
      "getUrineTestResultsUpdateStatus",
      "getAllTestResults",
      "getUrineReportGenerateStatus",
      "getToxicInformation",
      "getToxicologyTestResultUpdateStatus",
      "getToxicologyResultsAddStatus",
      "getToxicologyReportGenerateStatus",
      "getUrineMachineResults",
      "getPrilimenaryReportStatus",
      "getSingleCaseTestsInfo",
      "getPreviousCaseResults"
    ]),
    ...mapGetters("auth", [
      "getAuthenticatedUser",
      "getUserAllowedLabs",
      "getUserPrimaryLabId",
      "getAuthenticationDetails"
    ]),
    ...mapGetters("profile", ["getProfileData"]),
    ...mapGetters("errors", ["getError"]),
    checkUser() {
      if (
        this.getAuthenticatedUser &&
        this.getAuthenticatedUser.user_type == "LAB_TECHNOLOGIST"
      ) {
        return true;
      }
      return false;
    },
    hasAllowedCaseType() {
      if (
        this.getAuthenticatedUser.allowed_case_types &&
        this.getAuthenticatedUser.allowed_case_types.length
      ) {
        if (
          this.getCaseInformation &&
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.length
        ) {
          const cases = this.getCaseInformation.case_types;
          const casetypes = this.getAuthenticatedUser.allowed_case_types;

          if (cases.every((item) => casetypes.includes(item))) {
            return true;
          } else {
            return false;
          }
        }
      }
      return false;
    },

    hasBloodPanel() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    hasUrineTest() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("URINALYSIS") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    isHavingOneResults() {
      if (this.urineResults && Object.keys(this.urineResults).length == 1) {
        return true;
      }
      return false;
    },
    hasToxicTest() {
      if (this.getCaseInformation) {
        if (
          this.getCaseInformation.case_types &&
          this.getCaseInformation.case_types.indexOf("TOXICOLOGY") > -1
        ) {
          return true;
        } else {
          return false;
        }
      }
      return true;
    },
    checkLab() {
      if (this.getUserAllowedLabs && this.getUserPrimaryLabId) {
        const matchedLab = this.getUserAllowedLabs.find(
          (lab) => lab._id === this.getUserPrimaryLabId
        );
        if (matchedLab && (matchedLab.lab_code == "DLW-TX" || matchedLab.lab_code == "DLW-HOU" || matchedLab.lab_code == "DLW")) {
          return true;
        }
        return false;
      }
      return false;
    },
  },
  methods: {
    // return css class based on flag text and whether a result exists
    getFlagClass(flag, result) {
      const text = (flag || "").toString().toUpperCase();
      // when there is no result, show muted/placeholder style
      if (!result && result !== 0) return "flag-empty";
      if (text.includes("CRITICAL HIGH") || text.includes("CRITICAL LOW") || text.includes("CRITICAL")) return "flag-critical";
      if (text.includes("HIGH") || text.includes("LOW")) return "flag-highlow";
      return "flag-normal";
    },
    async fetchUrinalysisPreviousResults() {
      try {
        const c = this.getCaseInformation;
        const pid = c.patient_info?.internal_patient_id || c.internal_patient_id || c.patient_info?._id;
        if (!pid) return;
        const res = await $axios.post('/patient-case-results/blood-test-result-files', {
          internal_patient_id: pid,
          case_types: 'URINALYSIS',
        });
        const items = (res.data?.data || []).sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        const resultMap = {};
        const accessions = [];
        const seenAcc = new Set();
        for (const item of items) {
          const acc = item.sample_name_id;
          if (acc === this.accession_id) continue;
          if (!seenAcc.has(acc)) {
            seenAcc.add(acc);
            accessions.push({ acc, date: item.created_at || '' });
          }
          for (const group of (item.result_summary || [])) {
            for (const r of (group.results || [])) {
              const key = (r.result_name || '').trim().toLowerCase();
              if (!resultMap[key]) resultMap[key] = {};
              resultMap[key][acc] = { value: r.result_value, flag: r.flag };
            }
          }
        }
        this.urinePreviousResults = resultMap;
        this.urinePreviousAccessions = accessions;
      } catch (err) {
        console.error('Error fetching urine previous results:', err);
      }
    },
    getUrinePreviousValue(resultName, accession) {
      const key = (resultName || '').trim().toLowerCase();
      return this.urinePreviousResults[key]?.[accession] || null;
    },
    getUrineFlagClass(flag) {
      const f = (flag || '').toUpperCase();
      if (f === 'ABNORMAL') return 'urine-flag--abnormal';
      if (f === 'NORMAL') return 'urine-flag--normal';
      return '';
    },
    fetchPreviousResults() {
      try {
        const response = this.getPreviousCaseResults;
        const resultMap = {};
        const dateSet = new Set();

        if (response && response.data && response.data.length > 0) {
          response.data.forEach(caseItem => {
            const caseDate = new Date(caseItem.reported_date).toISOString().split("T")[0]; // normalized date

            (caseItem.results || []).forEach(r => {
              const key = `${r.result_name.trim().toLowerCase()}__${r.test_name_code || 'NA'}`;
              if (!resultMap[key]) resultMap[key] = [];

              resultMap[key].push({
                result: r.result,
                flag: r.flag,
                date: caseDate,
                code: r.test_name_code || 'NA',
              });

              dateSet.add(caseDate);
            });
          });
        }

        for (const key in resultMap) {
          resultMap[key].sort((a, b) => new Date(a.date) - new Date(b.date));
        }

        this.previousResults = resultMap;
        this.previousResultDates = Array.from(dateSet).sort((a, b) => new Date(b) - new Date(a));
      } catch (err) {
        console.error("Error fetching previous results:", err);
      }
    },
      //  Get previous results (multiple same-date entries side-by-side)
    getPreviousResultsWithFlagsForDate(testName, date, testCode = "NA") {
      const key = `${testName?.trim()?.toLowerCase()}__${testCode}`;
      const entries = this.previousResults[key];
      if (!entries || !entries.length) return "-";
      const matches = entries.filter(e => e.date === date);
      if (!matches.length) return "-";
      return matches
        .map(e => {
          const result = (e.result ?? "") === "" ? "-" : e.result;
          // const flagText = e.flag ? `[${this.normalizeFlag(e.flag)}]` : "";
          // const flagClass = this.getFlagClass(e.flag, e.result);
          return `
            <span class='result-item'>
              <span class='result-value'>${result}</span>
            </span>
          `;
        })
        .join(" ");
    },
    // Normalize flags
    normalizeFlag(flag) {
      if (!flag) return "-";
      const normalized = flag.trim().toUpperCase();
      switch (normalized) {
        case "HIGH":
          return "H";
        case "LOW":
          return "L";
        case "CRITICAL HIGH":
          return "CH";
        case "CRITICAL LOW":
          return "CL"; 
        case "ABNORMAL":
          return "AN"; 
        case "NORMAL":
          return "N";
        default:
          return normalized;
      }
    },
    formatDate(date) {
      const d = new Date(date);
      if (isNaN(d)) return "";
      return d
        .toLocaleDateString("en-US", {
          month: "2-digit",
          day: "2-digit",
          year: "numeric"
        })
        .replace(/\//g, "-");
    },
    onlyNumberOrComparison($event) {
      const keyCode = $event.keyCode ? $event.keyCode : $event.which;
      const char = String.fromCharCode(keyCode);
      const currentValue = ($event.target.value || '').toString();
      if ((keyCode >= 48 && keyCode <= 57) || keyCode === 46) return;
      if ((char === '<' || char === '>') && !/[<>]/.test(currentValue)) return;
      $event.preventDefault();
    },
    updateFlag(test, rowIndex) {
      const row = test[rowIndex];
      if (row.result !== null && row.result !== undefined) {
        const str = row.result.toString();
        const prefix = /^[<>]/.test(str) ? str[0] : '';
        const numPart = prefix ? str.slice(1) : str;
        const truncated = numPart.replace(/^(\d+)(\.\d{0,3})?.*$/, '$1$2');
        row.result = prefix + truncated;
      }
      const str = (row.result || '').toString().trim();
      const prefix = /^[<>]/.test(str) ? str[0] : '';
      const numericValue = parseFloat(prefix ? str.slice(1) : str);
      if (isNaN(numericValue)) {
        row.flag = null;
        return;
      }
      const result = prefix === '<' ? numericValue - 0.1
                   : prefix === '>' ? numericValue + 0.1
                   : numericValue;
      const referenceRangeFlags = row.reference_range_flags;
      for (const range of referenceRangeFlags) {
        const from = parseFloat(range.from);
        const to = parseFloat(range.to);
        if (result >= from && result <= to) {
          row.flag = range.flag;
          break;
        }
      }
    },
    openResultsPopup() {
      this.dialogVisible = true;
    },
    closeDialog() {
      this.dialogVisible = false;
    },
    updateUrineResults(results) {
      this.urineTestResults = results;
      if (this.urineTestResults && this.urineTestResults.length) {
        let group = this.urineTestResults.reduce((r, a) => {
          r[a.test_name] = [...(r[a.test_name] || []), a];
          return r;
        }, {});
        this.urineResults = group;
      }
      this.askConfirmation();
    },
    askConfirmation() {
      try {
        this.$confirm("Are you sure to save test results?", "Warning", {
          confirmButtonText: "OK",
          cancelButtonText: "Cancel",
          type: "warning",
        })
          .then(() => {
            this.updateUrineResultsData();
          })
          .catch(async () => {
            this.checkCaseInformation();
          });
      } catch (err) {
        console.log(err);
      }
    },
    async askReason() {
      this.takeReasonDialog = true;
    },
    async updateToxicologyResults(reason) {
      try {
        this.loading = true;
        let confirmation_results = this.prepareConfirmationResults();
        let params = {
          sample_id: this.caseId,
        };
        params.update_reason = reason;
        params.result_summary = {
          confirmation_results: confirmation_results,
          screen_results: this.screenResults,
          screen_validity: this.screenValidity,
          screen_result_id: this.reportData.sample_name,
          prescribed_medications: this.prescribedMedications,
        };
        await this.$store.dispatch("cases/updateToxicologyTestResults", params);
        if (this.getToxicologyTestResultUpdateStatus) {
          this.$notify.success({
            title: "Success",
            message: "Test results details updated successfully",
          });
          await this.checkCaseInformation();
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error in updating Test results details",
          });
        }
        this.loading = false;
        this.takeReasonDialog = false;
      } catch (error) {
        console.log(error);
      }
    },

    async previewToxicologyResults() {
      let routerData = this.$router.resolve({
        name: "ToxicologyTestResultsPreview",
        params: {
          case_id: this.caseId,
        },
      });
      window.open(routerData.href, "_blank");
    },
    prepareConfirmationResults() {
      let data = [];
      this.categoryCodes.map((category) => {
        data = [...data, ...category.results];
      });
      return data;
    },
    checkScreeningTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        const testName = (test.test_name || test.report_test_name || "").trim().toUpperCase();
        if (["PH", "URINE CREATININE", "OXIDANTS"].includes(testName)) {
          if (value < test.low_limit || value > test.high_limit) {
            test.result_value = "Abnormal";
          } else {
            test.result_value = "Normal";
          }
        } else if (value > test.cutoff) {
          test.result_value = "Positive";
        } else {
          test.result_value = "Negative";
        }
      }
    },

    checkScreeningValidityTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        if (value < test.low_limit || value > test.high_limit) {
          test.result_value = "Abnormal";
        } else {
          test.result_value = "Normal";
        }
      } else {
        test.result_value = "Normal";
      }
    },
    checkConfirmationTestValues(test) {
      if (test.result) {
        let value = parseFloat(test.result);
        if (value > test.cutoff) {
          test.flag = "Positive";
          if (value > test.ULMI) {
            test.invalid_range = ">" + test.ULMI;
          } else {
            test.invalid_range = "";
          }
        } else {
          test.flag = "Not Detected";
          if (value < test.LLMI) {
            test.invalid_range = "<" + test.LLMI;
          } else {
            test.invalid_range = "";
          }
        }
      } else {
        test.invalid_range = "";
        test.flag = "Not Detected";
      }
      this.updateInterpretationForSelectedTest(test);
    },
    updateInterpretationForSelectedTest(selectedTest) {
      let CONSISTENT, confirmation, comment;
      let flag = selectedTest.flag;
      let grouped = [];
      let testMedications = selectedTest.mapped_medications || [];
      testMedications.push(selectedTest.medication);
      if (selectedTest.test_name) {
        testMedications.push(selectedTest.test_name);
      }
      let found = false;
      if (testMedications && testMedications.length) {
        testMedications = testMedications.map((e) => e.toUpperCase());
        grouped = this.arrayInterSection(
          testMedications,
          this.prescribedMedications
        );
        found = grouped.length > 0;
      }

      if (found) {
        if (flag == "Not Detected") {
          CONSISTENT = "INCONSISTENT";
        } else if (flag === "Not Tested") {
          CONSISTENT = "NOT TESTED";
        } else {
          CONSISTENT = "CONSISTENT";
        }

        comment = "Prescribed";
        confirmation = true;
      } else {
        if (flag == "Positive") {
          CONSISTENT = "INCONSISTENT";
          confirmation = true;
          comment = "Not Prescribed";
        } else if (flag === "Not Tested") {
          CONSISTENT = "NOT TESTED";
        } else {
          CONSISTENT = "CONSISTENT";
        }
      }
      if (selectedTest.not_tested) {
        delete selectedTest["not_tested"];
      }
      selectedTest.interpretation = CONSISTENT;
      selectedTest.confirmation = confirmation;
      selectedTest.comment = comment;
    },
    getCategoryCodeData(category, data) {
      return data
        .filter((result) => {
          if (result.category == category) {
            return result;
          }
        })
        .sort((a, b) => a.report_test_name.localeCompare(b.report_test_name));
    },
    async generateToxiocologyReport() {
      try {
        this.loading = true;
        await this.$store.dispatch(
          "cases/generateToxicologyReport",
          this.caseId
        );

        this.loading = false;
        if (this.getToxicologyReportGenerateStatus) {
          this.$notify.success({
            title: "Success",
            message: "Toxicology Report Generated Successfully",
          });
          setTimeout(() => {
            window.location.reload();
          }, 500);
          // this.testReportURL = this.getTestReportURL;
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error on generating test report",
          });
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async fetchToxicInformation() {
      try {
        this.loading = true;

        await this.$store.dispatch("cases/fetchToxicResults", this.caseId);

        if (this.getToxicInformation) {
          this.reportData = this.getToxicInformation;
          if (
            this.reportData &&
            this.reportData.result_summary &&
            ((this.reportData.result_summary.screen_results &&
              this.reportData.result_summary.screen_results.length) ||
              this.reportData.result_summary.screen_validity.length ||
              this.reportData.result_summary.confirmation_results.length)
          ) {
            this.showResultsEditing = true;
          } else {
            this.showResultsEditing = false;
          }
          this.medications =
            this.reportData &&
            this.reportData.result_summary &&
            this.reportData.result_summary.prescribed_medications &&
            this.reportData.result_summary.prescribed_medications.length
              ? this.reportData.result_summary.prescribed_medications.join(
                  ",  "
                )
              : "- No Medications -";
          this.prescribedMedications =
            this.reportData &&
            this.reportData.result_summary &&
            this.reportData.result_summary.prescribed_medications &&
            this.reportData.result_summary.prescribed_medications.length
              ? this.reportData.result_summary.prescribed_medications
              : [];
          // this.screenResults = this.reportData[i].results;
          this.screenResults =
            this.reportData?.result_summary?.screen_results || [];
          this.screenValidity =
            this.reportData?.result_summary?.screen_validity || [];

          this.confirmationResults =
            this.reportData?.result_summary?.confirmation_results || [];

          this.confirmationResults = this.confirmationResults.sort(function (
            a,
            b
          ) {
            return ("" + a.category_code).localeCompare(b.category_code);
          });

          this.hasConfirmationTests = this.confirmationResults.length
            ? true
            : false;
          this.hasScreeingTests = this.screenResults.length ? true : false;

          this.screenResults = this.screenResults.sort(function (a, b) {
            return ("" + a.report_test_name).localeCompare(b.report_test_name);
          });

          this.hasScreeingValidity = this.screenValidity.length ? true : false;

          this.screenValidity = this.screenValidity.sort(function (a, b) {
            return ("" + a.report_test_name).localeCompare(b.report_test_name);
          });

          this.categoryCodes = this.confirmationResults.map(
            (result) => result.category
          );

          // removed duplicates
          this.categoryCodes = [...new Set(this.categoryCodes)];

          this.categoryCodes = this.categoryCodes.map((categoryCode) => {
            return {
              name: categoryCode,
              results: this.getCategoryCodeData(
                categoryCode,
                this.confirmationResults
              ),
            };
          });
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
        this.loading = false;
      }
    },
    async checkCaseInformation() {
      try {
        this.loading = true;
        this.caseId = this.$route.params.case_id;
        if (!this.getCaseInformation) {
          this.loading = false;
          return;
        }
        this.accession_id = this.getCaseInformation.accession_id;

        if (!this.caseId) {
          this.loading = false;
          this.$router.push({
            to: "/all-cases",
          });
        } else {
          await Promise.all([
            // this.$store.dispatch("cases/fetchCaseInformation", this.caseId),
            this.$store.dispatch("cases/fetchTestResults", {
              caseId: this.caseId,
            }),
          ]);
          if (!this.getCaseInformation) {
            this.disablePatientInformation = true;
          }

          this.caseStatus = this.getCaseInformation.status;
          if (
            this.getCaseInformation &&
            this.getCaseInformation.case_types.indexOf("CLINICAL_CHEMISTRY") >
              -1
          ) {
            this.activeCaseName = "blood";
            await this.$store.dispatch("cases/fetchBloodTestResults", {
              caseId: this.caseId,
            });
            await this.$store.dispatch("cases/fetchPreviousCaseResults", {
              caseId: this.caseId,
            });
            // populate local previousResults / previousResultDates from the getter
            this.fetchPreviousResults();
            if (this.getAllTestResults && this.getAllTestResults.data) {
              this.testResults = this.getAllTestResults?.data?.results;
              this.bloodTestData = this.getAllTestResults?.data;
              this.bloodComment = this.getAllTestResults?.data?.comments || "";
            }
            if (this.testResults && this.testResults.length) {
              let group = this.testResults.reduce((r, a) => {
                r[a.test_name_code] = [...(r[a.test_name_code] || []), a];
                return r;
              }, {});
              this.bloodResults = group;
            }
          } else if (
            this.getCaseInformation &&
            this.getCaseInformation.case_types.indexOf("URINALYSIS") > -1
          ) {
            this.activeCaseName = "urine";
            await this.$store.dispatch("cases/fetchAllUrineTestResults", {
              caseId: this.caseId,
            });
            await this.$store.dispatch("cases/fetchUrineMachineResults", {
              accession_id: this.accession_id,
            });
            this.testResultsForUrine = this.getUrineTestResults.urineTest;
            this.urineTestResults = this.getUrineTestResults.urineTest;
            if (this.urineTestResults && this.urineTestResults.length) {
              let group = this.urineTestResults.reduce((r, a) => {
                r[a.test_name] = [...(r[a.test_name] || []), a];
                return r;
              }, {});
              this.urineResults = group;
            }
            if (
              this.getUrineMachineResults &&
              this.getUrineMachineResults.results
            ) {
              this.machineResults = this.getUrineMachineResults.results;
              this.sortResultValues();
              this.mismatched = this.checkDifference(
                this.machineResults,
                this.urineTestResults
              );
            }
            await this.fetchUrinalysisPreviousResults();
          } else if (
            this.getCaseInformation &&
            this.getCaseInformation.case_types.indexOf("TOXICOLOGY" > -1)
          ) {
            this.activeCaseName = "toxic";
            await this.fetchToxicInformation();
          }
          this.loading = false;
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    sortResultValues() {
      this.machineResults.sort(function (a, b) {
        if (a.result_key < b.result_key) {
          return -1;
        }
        if (a.result_key > b.result_key) {
          return 1;
        }
        return 0;
      });
    },
    checkDifference(machineResults, testResults) {
      const machineValues = machineResults.map(({ value }) => value);
      const resultValues = testResults.map(({ result_value }) => result_value);

      if (machineValues.length !== resultValues.length) {
        return true;
      }

      for (let i = 0; i < machineValues.length; i++) {
        if (machineValues[i] !== resultValues[i]) {
          return true;
        }
      }

      return false;
    },
    async selectedTabTest() {
      if (this.activeCaseName && this.activeCaseName == "urine") {
        this.showResultsEditing = false;
        await this.$store.dispatch("cases/fetchAllUrineTestResults", {
          caseId: this.caseId,
        });
        await this.$store.dispatch("cases/fetchUrineMachineResults", {
          accession_id: this.accession_id,
        });
        if (
          this.getUrineMachineResults &&
          this.getUrineMachineResults.results
        ) {
          this.machineResults = this.getUrineMachineResults.results;
        }
        this.testResultsForUrine = this.getUrineTestResults.urineTest;
        this.urineTestResults = this.getUrineTestResults.urineTest;
        if (this.urineTestResults && this.urineTestResults.length) {
          let group = this.urineTestResults.reduce((r, a) => {
            r[a.test_name] = [...(r[a.test_name] || []), a];
            return r;
          }, {});
          this.urineResults = group;
        }
      } else if (this.activeCaseName && this.activeCaseName == "blood") {
        this.showResultsEditing = false;

        await this.$store.dispatch("cases/fetchAllTestResults", {
          accession_number: this.accession_id,
          get_all: true,
        });
        this.testResults = this.getAllTestResults?.data;
        if (this.testResults && this.testResults.length) {
          let group = this.testResults.reduce((r, a) => {
            r[a.test_name] = [...(r[a.test_name] || []), a];
            return r;
          }, {});
          this.bloodResults = group;
        }
      } else if (this.activeCaseName && this.activeCaseName == "toxic") {
        this.fetchToxicInformation();
      }
    },
    async startToxicologyResulting() {
      try {
        this.loading = true;
        await this.$store.dispatch("cases/createToxicTestResults", this.caseId);
        this.loading = false;
        if (this.getToxicologyResultsAddStatus) {
          this.$notify.success({
            title: "Success",
            message: "Test Results Added Successfully",
          });
          this.activeCaseName = "toxic";
          this.fetchToxicInformation();
        } else {
          this.$notify.error({
            title: "Error",
            message: "Error while creating test results",
          });
        }
      } catch (err) {
        console.log(err);
      }
    },
    async startResulting() {
      try {
        let urineTestsData;
        if (this.checkLab) {
          urineTestsData = this.urineTestsNew;
        } else {
          urineTestsData = this.urineTests;
        }
        for (let i = 0; i < urineTestsData.length; i++) {
          urineTestsData[i].case_id = this.caseId;
          urineTestsData[i].accession_number = this.accession_id;
        }

        this.loading = true;
        let params = {
          urineTestResults: urineTestsData,
          case_id: this.caseId,
        };
        await this.$store.dispatch("cases/createUrineTestResults", params);
        this.loading = false;
        if (this.getResultsAddStatus) {
          successNotification("Test Results Added Successfully");
          this.activeCaseName = "urine";
          this.checkCaseInformation();
        } else {
          errorNotification("Error while creating test results");
        }
      } catch (err) {
        this.loading = false;
        console.log(err);
      }
    },
    async previewTestResultsData() {
      let routerData = this.$router.resolve({
        name: "ResultFileBloodHTMLData",
        params: {
          accession_id: this.accession_id,
          case_id: this.$route.params.case_id,
        },
      });
      window.open(routerData.href, "_blank");
    },

    async previewUrineTestResultsData() {
      let routerData = this.$router.resolve({
        name: "ResultFileUrineHTMLData",
        params: {
          accession_id: this.accession_id,
          case_id: this.$route.params.case_id,
        },
      });
      window.open(routerData.href, "_blank");
    },
    async generateUrineReport() {
      try {
        this.loading = true;
        let params = {
          case_type: "URINALYSIS",
          case_id: this.caseId,
        };
        await this.$store.dispatch("cases/generateUrineTestReport", params);

        this.loading = false;

        if (this.getUrineReportGenerateStatus) {
          successNotification("Test Report Generated Successfully");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          errorNotification("Error on generating test report");
        }
      } catch (err) {
        console.log(err);
      }
    },
    async saveAndGenerateUrineReport() {
      try {
        // First, save the results
        this.loading = true;
        let params = {
          urine_test_results: this.urineTestResults,
          caseId: this.caseId,
        };
        await this.$store.dispatch("cases/updateUrineTestResults", params);
        
        if (this.getUrineTestResultsUpdateStatus) {
          successNotification("Urine Result Updated Successfully");
          
          // If save is successful, generate the report
          let reportParams = {
            case_type: "URINALYSIS",
            case_id: this.caseId,
          };
          await this.$store.dispatch("cases/generateUrineTestReport", reportParams);
          
          this.loading = false;
          
          if (this.getUrineReportGenerateStatus) {
            successNotification("Test Report Generated Successfully");
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            errorNotification("Error on generating test report");
          }
        } else {
          this.loading = false;
          errorNotification("Error on updating test report");
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
        errorNotification("Error on saving and generating test report");
      }
    },
    async generateReport() {
      let params = {
        case_id: this.$route.params.case_id,
      };
      try {
        this.loading = true;

        await this.$store.dispatch("cases/generateBloodTestReport", params);

        this.loading = false;

        if (this.getBloodReportGenerateStatus) {
          successNotification("Test Report Generated Successfully");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          errorNotification("Error on generating test report");
        }
      } catch (err) {
        console.log(err);
      }
    },

    async updateUrineResultsData() {
      try {
        this.loading = true;

        let params = {
          urine_test_results: this.urineTestResults,
          caseId: this.caseId,
        };
        await this.$store.dispatch("cases/updateUrineTestResults", params);
        this.loading = false;

        if (this.getUrineTestResultsUpdateStatus) {
          successNotification("Test Report Updated Successfully");
          await this.checkCaseInformation();
        } else {
          errorNotification("Error on updating test report");
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    openDialogForReport() {
      this.confirmDialogVisible = true;
    },
    async handleCancel() {
      this.confirmDialogVisible = false;
      await this.updateResultsData(false); // Call without generating preliminary report
    },
    async generatePriliminaryReport() {
      try {
        this.loading = true;
        // await this.updateResultsData();
        await this.$store.dispatch("cases/generatePrilimenaryReports", {
          caseId: this.caseId,
          auth:this.getAuthenticationDetails.access_token
        });

        this.loading = true;
        if (this.getPrilimenaryReportStatus) {
          successNotification("Priliminary Report Generated Successfully");
          setTimeout(() => {
            window.location.reload();
          }, 500);
        } else {
          errorNotification("Error on generating test report");
        }
      } catch (err) {
        console.log(err);
      }
      // this.confirmDialogVisible = false;
      // await this.updateResultsData(true);  // Call with generating preliminary report
    },
    async saveAndGenerateBloodReport() {
      try {
        // First, save the results
        this.loading = true;
        const comparisonRegex = /^[<>]\s*\d+(\.\d+)?$/;
        const validStrings = [
          "POSITIVE",
          "NEGATIVE",
          "REACTIVE",
          "NON REACTIVE",
          "INCONCLUSIVE",
        ];
        this.testResults.forEach((obj) => {
          if (validStrings.includes(obj.result)) {
            obj.result = obj.result;
          } else if (obj.result === 0 || obj.result === "0") {
            obj.result = "0";
          } else if (
            obj.result === null ||
            obj.result === undefined ||
            obj.result === ""
          ) {
            obj.result = null;
          } else if (!isNaN(obj.result) && !isNaN(parseFloat(obj.result))) {
            obj.result = obj.result;
          } else if (typeof obj.result === "string" && comparisonRegex.test(obj.result)) {
            obj.result = obj.result;
          } else {
            obj.result = null;
          }
        });
        let params = {
          case_id: this.bloodTestData.case_id,
          accession_id: this.bloodTestData.accession_id,
          first_name: this.bloodTestData.first_name,
          last_name: this.bloodTestData.last_name,
          middle_name: this.bloodTestData.middle_name,
          gender: this.bloodTestData.gender,
          date_of_birth: this.bloodTestData.date_of_birth,
          results: this.testResults,
          comments: this.bloodComment || "",
        };
        if (this.isAbleToGenerateResendEMR) {
          params.is_forced = true;
        }
        await this.$store.dispatch("cases/updateTestResults", params);
        
        if (this.getTestResultsUpdateStatus) {
          successNotification("Blood Results Updated Successfully");
          
          // If save is successful, generate the preliminary report
          await this.$store.dispatch("cases/generatePrilimenaryReports", {
            caseId: this.caseId,
            auth: this.getAuthenticationDetails.access_token
          });
          
          this.loading = false;
          
          if (this.getPrilimenaryReportStatus) {
            successNotification("Preliminary Report Generated Successfully");
            setTimeout(() => {
              window.location.reload();
            }, 500);
          } else {
            errorNotification(
              this.getError || "",
              "Error on generating preliminary report"
            );
          }
        } else {
          this.loading = false;
          errorNotification(
              this.getError || "",
              "Error on updating test report"
            )
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
        errorNotification("Error on saving and generating test report");
      }
    },
    async updateResultsData() {
      try {
        this.loading = true;
        const comparisonRegex = /^[<>]\s*\d+(\.\d+)?$/;
          const validStrings = [
            "POSITIVE",
            "NEGATIVE",
            "REACTIVE",
            "NON REACTIVE",
            "INCONCLUSIVE",
          ];
        this.testResults.forEach((obj) => {
          if (validStrings.includes(obj.result)) {
            obj.result = obj.result;
          } else if (obj.result === 0 || obj.result === "0") {
            obj.result = "0";
          } else if (
            obj.result === null ||
            obj.result === undefined ||
            obj.result === ""
          ) {
            obj.result = null;
          } else if (!isNaN(obj.result) && !isNaN(parseFloat(obj.result))) {
            obj.result = obj.result;
          } else if (typeof obj.result === "string" && comparisonRegex.test(obj.result)) {
            obj.result = obj.result;
          } else {
            obj.result = null;
          }
        });
        let params = {
          case_id: this.bloodTestData.case_id,
          accession_id: this.bloodTestData.accession_id,
          first_name: this.bloodTestData.first_name,
          last_name: this.bloodTestData.last_name,
          middle_name: this.bloodTestData.middle_name,
          gender: this.bloodTestData.gender,
          date_of_birth: this.bloodTestData.date_of_birth,
          results: this.testResults,
          comments: this.bloodComment || "",
        };
        if (this.isAbleToGenerateResendEMR) {
          params.is_forced = true;
        }
        await this.$store.dispatch("cases/updateTestResults", params);
        this.loading = false;

        if (this.getTestResultsUpdateStatus) {
          successNotification("Test Report Updated Successfully");
          await this.checkCaseInformation();
        } else {
          errorNotification("Error on updating test report");
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
      }
    },
    checkAllgenPanel(row) {
      return (
        row[0]?.m_code === "AP3600"
      );
    },
  },
  watch: {
    getCaseInformation: {
      handler(newCaseInfo) {
        if (newCaseInfo && newCaseInfo.accession_id) {
          this.accession_id = newCaseInfo.accession_id;
        }
        if (newCaseInfo && newCaseInfo.status) {
          this.caseStatus = newCaseInfo.status;
        }
      },
      immediate: true,
      deep: true,
    },
  },
};
</script>
<style lang="scss">
.attachments {
  .test-results {
    .test-btn {
      position: absolute;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: end;
      margin: 0 15px;
      z-index: 9;

      li {
        .test-preview {
          background-color: #4bb543;
          border: none;
          color: white;
          margin-right: 16px;
          min-height: 30px;
          padding: 5px 16px;
          border-radius: 5px;
        }

        .test-reports {
          background-color: #273480;
          border: none;
          color: white;
          min-height: 30px;
          padding: 5px 16px;
          margin-right: 7px;
          border-radius: 5pxs;
        }

        .view-results {
          background-color: transparent;
          border: none;
          text-decoration: underline;
          color: #0a5da6;
          font-size: 15px;
          min-height: 30px;
          padding: 5px 16px;
          margin-right: 7px;
          border: none;
        }
      }
    }

    .test-success {
      margin: 0 15px 0 10px;
      // color: #0a5da6;
      color: #4bb543;
      font-size: 14px;
      font-weight: 500;
    }

    .test-mismatched {
      margin: 0 15px 0 10px;
      color: #f28b0c;
      font-size: 14px;
      font-weight: 500;
    }

    .test-danger {
      margin: 0 15px 0 10px;
      color: #f24a55;
      font-size: 14px;
      font-weight: 500;
    }
  }

  .results-tabs {
    // padding: 0 20px;
    .el-tabs__active-bar {
      background-color: #0a5da6;
      border-radius: 25px;

      height: 2px;
    }

    .el-tabs__item {
      color: #828282;

      &.is-active {
        color: #0a5da6;
      }
    }

    .el-tabs__nav-wrap.is-scrollable {
      width: 75%;
      position: relative;
      left: 20px;
      padding: 0 60px 0 20px;

      @media (min-width: 1200px) and (max-width: 1650px) {
        width: 70% !important;
        padding: 0 30px 0 20px;
      }
    }

    .el-tabs__nav-scroll {
      padding: 0 20px;
      width: 100%;
      overflow-x: scroll;

      @media (min-width: 1200px) and (max-width: 1650px) {
        width: 97% !important;
      }
    }

    .el-tabs__nav-wrap {
      width: 75% !important;

      @media (min-width: 1200px) and (max-width: 1650px) {
        width: 70%;
      }
    }

    .el-icon {
      color: #000000;
    }

    .el-tabs__nav-wrap::after {
      height: 1px;
    }

    .el-tabs__content {
      padding: 0 20px;
    }

    .el-table th.el-table__cell.is-leaf {
      padding: 3px 0;
      background-color: #273480;
      color: #ffff;
      font-size: 13px;
    }

    .el-table .el-table__cell {
      padding: 5px 0;

      .el-input__inner {
        height: 34px;
      }
    }

    .save-btn {
      display: flex;
      justify-content: flex-end;
      padding: 5px 20px 10px;
      margin-top: 10px;

      .el-button {
        padding: 0px 16px;
        min-height: 29px;
        border: none;
        background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%) !important;

        &:hover {
          background: linear-gradient(
            79.26deg,
            #f24a55 -13.43%,
            #0a5da6 137.71%
          ) !important;
          color: #ffff !important;
        }
      }
    }
  }

  .hide-test-inputs {
    .el-tabs__active-bar {
      display: none;
    }

    .el-tabs__nav-wrap::after {
      height: 0;
    }

    .el-tabs__item {
      height: 0;
    }
  }
}

.testReportCommentBox {
  padding: 20px 20px 0 20px;
  width: 50%;

  .el-textarea__inner {
    height: 100px !important;
    border-radius: 10px;
    color: #273480;
    background: #ffffff;
    font-weight: 500;
  }

  textarea {
    resize: none;
  }
}
</style>
<style lang="scss">
.toxicology-edit-preview {
  max-height: 400px;
  min-height: 50px;
  overflow: auto;
  padding: 0 10px;

  .test-btn {
    position: absolute;
    right: 0;
    background: white;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 0 10px;
    z-index: 9;
  }

  h2 {
    padding: 1rem 5px 0;
    font-size: 20px;
  }

  .primary-header {
    padding: 1.5rem 5px 0.5rem;
    font-size: 16px;
  }

  .el-input__inner,
  .el-radio {
    height: 30px;
  }

  .date-type-checkbox {
    .el-radio__input .el-radio__inner {
      box-shadow: 0 0 0 1px #ced1d6;
      border-color: transparent;
    }

    .el-radio__input.is-checked .el-radio__inner {
      background-color: #0a5da6;
      border-color: #fff;
    }

    .el-radio__input.is-checked + .el-radio__label {
      color: #0a5da6;
    }
  }

  .listings__table .el-table table {
    border-spacing: 0 4.5px;
  }

  .el-table th.el-table__cell.is-leaf {
    padding: 3px 0;
    background-color: #273480;
    color: white;
    font-size: 13px;
  }

  .action-buttons {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 10px 2.2rem;
    background-color: #fff;

    &.fixed {
      position: fixed;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 99;
    }

    .btn {
      &.radius-button {
        background-color: #273480;

        &.radius-button-red {
          color: #273480;
          background: #fff;
          border: 1px solid #dedbdb;
          border-radius: 6px;

          &:hover,
          &:active,
          &:focus {
            box-shadow: 0 0 0 1px #dedbdb;
          }
        }
      }
    }
  }
}

.save-btn {
  display: flex;
  justify-content: flex-end;
  padding: 5px 20px 10px;
  border-bottom: 1.2px solid #e7e7f7;
  border-radius: 4px;

  .el-button {
    padding: 0px 16px;
    min-height: 29px;
    border: none;
    background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%) !important;

    &.is-disabled {
      opacity: 0.7;
      background: linear-gradient(79.26deg, #f24a55 -13.43%, #0a5da6 137.71%) !important;
    }
  }
}

.case-creation__test-reports {
  .el-tabs__content {
    min-height: 50px;
  }
}
</style>
<style lang="scss" scoped>
.blood-panel-test-results {
  .section-title{
    padding-bottom:0.5rem;
    padding-top: 0.2rem;
  }
  .el-input {
    position: relative;
    display: inline-flex;
    width: 100%;
    line-height: 36px;
  }

  .input-width {
    width: 80%;
  }
 .test-results{
  background-color: #fff;
  padding-bottom:2.2rem ;
 }
  .results-tabs {
    overflow-x: auto;
    white-space: nowrap;
    width: 100%;
.test-inputs{
   max-height: 500px;
   overflow-y: scroll;
   padding: 1rem;
   .el-table__body-wrapper{
    max-height: auto!important;
    overflow-y: visible!important;
   }
}
    .el-table {
      min-width: 1200px; 
    }
  }

  .el-table__header-wrapper {
    position: sticky;
    top: 0;
    background-color: #fff;
    z-index: 10;
  }
.previous-result-cell {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-start;
  gap: 7px;
  font-family: monospace;
  line-height: 1.6;
  white-space: nowrap;
  overflow-x: auto; 
  scrollbar-width: thin; 
  scrollbar-color: #d4d4d4 transparent;
  max-width: 100%; 
}
.previous-result-cell::-webkit-scrollbar {
  height: 3px; 
}

.previous-result-cell::-webkit-scrollbar-track {
  background: transparent; 
}

.previous-result-cell::-webkit-scrollbar-thumb {
  background-color: #bbb;
  border-radius: 10px;
}

.previous-result-cell:hover::-webkit-scrollbar-thumb {
  background-color: #888; 
}

::v-deep(.result-item) {
  display: inline-flex;
  align-items: center;
  justify-content: flex-start;
  padding: 2px 4.5px;
  border-radius: 4px;
  background-color: #f8f8f8;
  flex-shrink: 0;
  white-space: nowrap;
}

::v-deep(.result-value) {
  font-weight: 400;
  min-width: auto;
  text-align: left;
}

/* Flag styles */
.flag-cell {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    width: 100%;
  }
  .flag-placeholder {
    color: #999;
    font-style: italic;
    font-size: 12px;
    margin-left: 6px;
  }

  ::v-deep(.flag-value) {
    margin-left: 6px;
    padding: 2px 6px;
    border-radius: 4px;
    font-weight: 600;
    color: #000;
  }

  /* Critical = red */
  ::v-deep(.flag-critical),
  ::v-deep(.flag-critical) .el-input__inner {
    background: #ec212526 !important;
    color: #FC0D0D !important;
    border-color: transparent !important;
   }

  /* High/Low = orange */
  ::v-deep(.flag-highlow),
  ::v-deep(.flag-highlow) .el-input__inner {
    background: #f7983933 !important;
    color:#BF7C01 !important;
    border-color: transparent !important;
  }

  /* Normal / default */
  ::v-deep(.flag-normal),
  ::v-deep(.flag-normal) .el-input__inner {
    background: transparent !important;
    color: #222 !important;
    border-color: rgba(0,0,0,0.06) !important;
  }

  /* Empty / placeholder */
  ::v-deep(.flag-empty),
  ::v-deep(.flag-empty) .el-input__inner {
    background: transparent !important;
    color: #999 !important;
    border-color: rgba(0,0,0,0.06) !important;
  }
}

::v-deep(.urine-prev-header) {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  line-height: 1.3;

  .urine-prev-acc-label {
    font-size: 12px;
    font-weight: 700;
    letter-spacing: 0.3px;
  }

  .urine-prev-date-label {
    font-size: 10px;
    font-weight: 400;
    opacity: 0.85;
  }
}

::v-deep(.urine-prev-cell) {
  font-size: 13px;
  font-weight: 500;
  padding: 2px 4px;
  border-radius: 4px;
  text-align: center;
  color: #333;

  &.urine-flag--abnormal {
    background: #f7983933;
    color: #BF7C01;
  }

  &.urine-flag--normal {
    color: #333;
  }
}
</style>
